import _ from 'underscore';
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

export const withProps = (extraProps, WrappedComponent) => {
  const HoC = (props) => {
    const finalProps = _.isFunction(extraProps) ?
      extraProps(props) :
      _.extend({}, props, extraProps);
    return (
      <WrappedComponent {...finalProps} />
    );
  };

  HoC.displayName = `WithProps(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(HoC, WrappedComponent);

  return HoC;
};
